import React from 'react';
import SectionHeader from './SectionHeader';
import { Reveal, FadeIn } from './ScrollReveal';

export default function About() {
  const stats = [
    { val: "~12h", desc: "Direkter Kontakt<br/>pro Monat" },
    { val: "36M", desc: "Garantie-<br/>Zeithorizont" },
    { val: "0", desc: "Interessenkonflikte<br/>im Kreis", highlight: true },
    { val: "12", desc: "Partner max. —<br/>nie mehr", highlight: true }
  ];

  return (
    <section id="about" className="py-32 relative z-10 border-t border-brand-border">
      <div className="max-w-[1100px] mx-auto px-8">
        <SectionHeader 
          num="01" 
          eyebrow="Über Harald Suekar" 
          title="Executive Sparringpartner.<br/><em class='not-italic italic text-brand-gold'>Wien. DACH.</em>" 
        />
        
        <div className="grid grid-cols-1 lg:grid-cols-[380px_1fr] gap-16 lg:gap-24 items-start mt-10">
          <Reveal>
            <div className="relative w-full max-w-[420px] mx-auto lg:mx-0">
              <img 
                src="https://media-manager-c.questera.ai/greta-media/41772851bc8d661005b2321bbed342a06ca40a79090e73d1c35620e0ae66cbb7c0a509e5559c196e81b72c092a6bb019/images/aW1hZ2UvanBlZw==/f442b4e841b0b921f2ce632ea79b795e.jpg" 
                alt="Harald Suekar" 
                className="w-full h-auto object-cover border border-brand-border grayscale-[10%] contrast-[1.05] shadow-2xl" 
              />
            </div>
          </Reveal>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-16">
            <div>
              <Reveal delay={0.1}>
                <p className="font-serif text-[clamp(1.4rem,2.5vw,1.8rem)] font-light text-brand-white leading-[1.35] mb-8 tracking-tight">
                  Ich bin der Mensch, mit dem Unternehmer die Gespräche führen, die sie mit <em className="not-italic italic text-brand-gold">niemandem sonst</em> führen können.
                </p>
              </Reveal>
              <Reveal delay={0.2}>
                <p className="text-[1.1rem] text-brand-text leading-relaxed mb-6 font-light">
                  Nicht der Berater, der ein Konzept liefert und geht. Nicht der Coach, der nickt und bestätigt. Jemand, der nicht im System steckt, keine Rücksicht nehmen muss und sagt, was er sieht.
                </p>
              </Reveal>
              <FadeIn delay={0.4} className="mt-10 flex flex-col gap-5">
                {[
                  "Langjährige Erfahrung als Unternehmer & strategischer Berater",
                  "Sparring mit GF, Gründern und Solopreneuren quer durch alle Branchen",
                  "Entwickler des geschützten Peer-to-Peer Board Meeting Formats"
                ].map((item, i) => (
                  <div key={i} className="flex items-start gap-4 text-[1rem] text-brand-muted leading-relaxed border-l-2 border-brand-gold/30 pl-5">
                    <span className="text-brand-gold font-black shrink-0 mt-1">—</span>
                    {item}
                  </div>
                ))}
              </FadeIn>
            </div>

            <div className="md:border-l md:border-brand-border md:pl-12">
              <Reveal delay={0.2}>
                <p className="text-[1.1rem] text-brand-text leading-relaxed mb-8 font-medium">
                  Ich arbeite mit Unternehmern, die ihr Unternehmen wirklich auf die nächste Stufe bringen wollen — mit einem konkreten Zeithorizont und einer messbaren Messlatte.
                </p>
              </Reveal>
              <Reveal delay={0.3}>
                <p className="text-[1.1rem] text-brand-muted leading-relaxed mb-12 font-light">
                  Drei geschlossene Kreise, maximal 4 Mitglieder pro Kreis. 12 Partner insgesamt. Weil echtes Sparring Tiefe braucht.
                </p>
              </Reveal>
              
              <FadeIn delay={0.5} className="mt-12 grid grid-cols-2 gap-x-6 gap-y-14 pt-12 border-t border-brand-border">
                {stats.map((stat, i) => (
                  <div key={i} className="flex flex-col">
                    <div className={`font-serif text-[clamp(2.8rem,4vw,3.5rem)] font-light leading-none mb-4 ${stat.highlight ? 'text-brand-gold' : 'text-brand-white'}`}>
                      {stat.val}
                    </div>
                    <div className="text-[0.72rem] font-bold text-brand-muted uppercase tracking-[0.15em] leading-[1.5]" dangerouslySetInnerHTML={{ __html: stat.desc }} />
                  </div>
                ))}
              </FadeIn>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}